<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <!-- 				<el-input style="width: 300px; margin-right: 10px;" prefix-icon="el-icon-search" v-model="projectName"
					size="small" @keydown.enter.native="initLog" @clear="initLog" placeholder="请输入项目名称进行搜索..."
					clearable>
				</el-input> -->
        <el-date-picker
          size="mini"
          v-model="searchValue.ny"
          style="width: 200px"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择日志月份"
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          size="small"
          style="margin-left: 20px"
          >搜索</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="initData"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column
          prop="userId"
          label="用户ID"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="用户名"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="totalWorkDay"
          label="系统工作日数"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="wrokLogNum"
          label="提交日志天数"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="noLogNum"
          label="未提交工作天数"
          align="center"
          width="220"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              >查询明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>

    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog
      title="工作日志明细"
      :visible.sync="dialogVisible"
      width="60%"
      top="0px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-table
          :data="ListData"
          stripe
          :row-style="{ height: '10px' }"
          :cell-style="{ padding: '5px 0' }"
          size="small"
          style="width: 100%; height: 100%"
        >
          <!-- 多选框 -->
          <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
          <el-table-column
            prop="userId"
            label="用户id"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="rq"
            label="上报日期"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="填写日志时间"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注信息"
            align="center"
            width="200"
          >
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WlogTotal",
  data() {
    return {
      title: "",
      initData: [], // 存放查询结果
      ListData: [],
      searchValue: {
        ny: null,
        projectId: null,
        rqScope: "",
        period: "",
      },
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      projectName: "",
      dialogVisible: false,
      projects: [], //项目id-项目名称下拉框
      periods: [], //期次下拉框
    };
  },
  mounted() {
    this.initLog();
  },
  methods: {
    doClose() {
      this.dialogVisible = false;
    },
    doHandleDate() {
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      var tMonth = myDate.getMonth();
      var m = tMonth + 1;
      if (m.toString().length == 1) {
        m = "0" + m;
      }
      return tYear + "-" + m;
    },
    doChance() {
      this.dialogVisible = false;
      this.initLog();
    },
    showEditView(data) {
      this.dialogVisible = true;
      this.initDataList(data);
      // this.inputObj = data
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initLog();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initLog();
    },
    initDataList(data) {
      var ny = this.searchValue.ny;
      if (ny == null) {
        ny = this.doHandleDate();
      }
      this.getRequest(
        "/work_log/rep_detail?userId=" + data.userId + "&ny=" + ny
      ).then((resp) => {
        if (resp) {
          // alert(JSON.stringify(resp.data))
          this.ListData = resp.data;
        }
      });
    },
    // 搜索入口：先回到第 1 页再查
    onSearch() {
      this.page = 1;
      this.initLog();
    },

    initLog() {
      this.loading = true;
      let url =
        "/work_log/rep_total/?page=" + this.page + "&limit=" + this.limit;
      // 月份：选了就用选的，没选就用当前月。
      // 原来无参调用（首次进入 / 翻页 / 改页大小）会硬编码成 2021-12，是「翻页丢筛选」的根源。
      url += "&ny=" + (this.searchValue.ny || this.doHandleDate());

      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          // console.log(resp.data)
          // alert(JSON.stringify(resp.data))
          this.initData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style></style>
